(function () {
  const MAIL_SVG = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>';

  function isUnavailableInput(input) {
    return (!!input && input.classList.contains("is-unavailable") && !input.classList.contains("is-nonexistent"));
  }

  function getNotifyText() {
    return (window.theme && theme.strings && theme.strings.notifyMe) || "Notify me when available";
  }

  function updateNotifyTitles() {
    document.querySelectorAll(".opt-btn.js-option").forEach((input) => {
      const label = input.nextElementSibling;
      if (!label || !label.classList.contains("opt-label")) return;

      if (isUnavailableInput(input)) {
        label.title = getNotifyText();
      }
    });
  }

  function showNotifyIcons() {
    document.querySelectorAll(".opt-btn.js-option").forEach((input) => {
      const label = input.nextElementSibling;
      if (!label || !label.classList.contains("opt-label")) return;

      if (isUnavailableInput(input)) {
        const mailIcon = document.createElement("span");

        mailIcon.className = "stoq-notify-mail";
        mailIcon.innerHTML = MAIL_SVG;
        mailIcon.setAttribute("aria-hidden", "true");

        mailIcon.title = getNotifyText();
        label.style.position = label.style.position || "relative";
        label.appendChild(mailIcon);
      }
    });
  }

  function handleOptionClick(event) {
    const label = event.target.closest(".opt-label");
    if (!label) return;

    const input = label.previousElementSibling;
    if (!input || !input.classList.contains("opt-btn")) return;

    const addContainer = document.getElementById("add-container");
    if (!addContainer) return;

    addContainer.hidden = isUnavailableInput(input);
  }

  window.addEventListener("stoq:loaded", (event) => {
    const { enabled, settings } = event.detail;

    if (!enabled || !settings.storefront_button_disable_tag_enabled) {
      return;
    }

    const tags = JSON.parse(document.querySelector("#product-tags-data").textContent);
    const tag = settings.storefront_button_disable_tag;

    if (!settings.storefront_button_disable_tag_hides_button && tags.indexOf(tag) > 0) {
      setTimeout(() => {
        showNotifyIcons();
        updateNotifyTitles();
      }, 500);

      document.addEventListener("click", handleOptionClick);
      document.addEventListener("on:variant:change", updateNotifyTitles);
    }
  });
})();
